module.exports = __webpack_public_path__ + "img/avatar_member.8057e40e.jpg";